import React, { createContext, useState } from "react";


//NOTIONS


//Interface, para trabalhar melhor com os dados e o tipo deles
interface RouterInfo {
    url?: string,
    track?: string,
}

//Interface das propriedades do contexto, no meu caso, é o veiculo e o método de alteração do veiculo
interface RouterInfoContextProps {
    routerInfo: RouterInfo | null,
    setRouterInfo: React.Dispatch<React.SetStateAction<RouterInfo | null>>
}

//Criando o contexto, para passarmos ao Provider
export const RouterInfoContext = createContext<RouterInfoContextProps>({

    routerInfo: {
        url: '',
        track: ''
    },
    setRouterInfo: ()=>{return}
})

export const RouterInfoProvider: React.FC<any> = ({children})=>{
    
    const [routerInfo, setRouterInfo] = useState<RouterInfo | null>(null)

    return(
        <RouterInfoContext.Provider value={{routerInfo, setRouterInfo}}>
            {children}
        </RouterInfoContext.Provider>
    )
}